// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d47950d3","453":"841cfc43","455":"5f4fd6e1","977":"521c374a"}[chunkId] + ".chunk.js";
};